function EventGroupService($q, BBModel) {
    'ngInject';

    return {
        query(company, params) {
            const deferred = $q.defer();
            if (!company.$has('event_groups')) {
                deferred.reject('company does not have event_groups');
            } else {
                company.$get('event_groups', params).then((resource) => {
                    console.log("event groups loading");   
                    return resource.$get('event_groups', params).then((event_groups) => {
                                event_groups = Array.from(event_groups).map(event_group =>
                                    new BBModel.EventGroup(event_group));
                                return deferred.resolve(event_groups);
                            }
                        );
                    }
                    , (err) => {
                        return deferred.reject(err);
                    }
                );
            }
            return deferred.promise;
        }
    };
}

angular
    .module('BB')
    .service('EventGroupService', EventGroupService);




// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_services/event_group.service.js